export enum SortProperty {
    Rating,
    Quantity,
    DeliveryDays,
    DeliveryDate,
    Price
}